<template>
  <div>

  <div v-if="this.$store.getters.isLoggedIn === true">
    <user-menu />
  </div>
    <div class="main-wrapper signin-form center">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>

	    <div class="text-align-center margin-bottom-35" v-if="loading == true" style="font-size: 18px;">
        <b>Please wait ... </b>
      </div>
      <h1 class="text-align-center margin-bottom-35" v-if="loading == false">
        Access Denied
      </h1>

      <div class="text-align-right" v-if="this.$store.getters.isLoggedIn === true">
        <router-link :to="url">-- Go to Dashboard</router-link>
      </div>

      <div class="text-align-right" v-if="loading == false">
        <router-link to="/login">-- Go to Login</router-link>
      </div>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from './shared/user_menu.vue';
import router from '../router/index.js';
import store from '../store/store.js';
import axios from 'axios';

export default {
  data: function () {
    return {
      url: '',
      token: '',
      loading: false,
      attemptId: '',
    }
  },
  components: {
    UserMenu
  },
  methods: {
  	navigate(path) {
  	  router.push(path);
  	},
    validateToken: function() {
      this.loading = true;
      axios('/custom/mentor-assessment-validate',
        {
          method: 'POST',
          data: {
              "token": this.token,
          },
        }
      )
     .then((resp) => {
        this.attemptId = resp.data.attemptId;
        if(resp.data.accessFlag == false) {
          this.loading = false;
        }
        router.push('/mentor-assessment-landing-page/' + this.token + '/' + this.attemptId);
      })
     .catch(error => {

     });


    },
  },
  created() {
    this.token = this.$route.params.token;
    this.validateToken();
    if(this.$store.getters.isLoggedIn) {
      var roles = this.$store.state.roles;
      if((this.$store.state.switch_admin_username)) {
        if(this.$store.state.switch_admin_account_flag == 1) {
          this.url = '/school-admin-dashboard';
        }
        else {
          this.url = '/company-admin-dashboard';
        }
      }
      else if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
        this.url = '/admin-dashboard';
      }
      else if(roles.indexOf('ROLE_ADMIN') > -1) {
        if(this.$store.state.school_flag == 1) {
          this.url = '/school-admin-dashboard';
        }
        else {
          this.url = '/company-admin-dashboard';
        }
      }
      else if(roles.indexOf('ROLE_MENTOR') > -1) {
        this.url = '/mentees-tasks-list';
      }
      else if(roles.indexOf('ROLE_INSTRUCTOR') > -1) {
        this.url = '/students-tasks-list';
      }
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/components/mentor_assessment_validate_token.vue